module.exports = __webpack_public_path__ + "static/DTT_Autobus-297ab136c1b6470d2600a9e701161189.png";